import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../views/Login.vue';
import LoginChoose from '../views/LoginChoose.vue';
import Login365 from '../views/Login365.vue';
import LoginQR from '../views/LoginQR.vue';
import Zebra from '../views/zebra.vue';
import ActiveLogins from '../views/ActiveLogins.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    children: [
      {
        path: '',
        name: 'choose',
        component: LoginChoose,
      },
      {
        path: '/365',
        name: '365',
        component: Login365,
      },
      {
        path: '/qr',
        name: 'qr',
        component: LoginQR,
      },
      {
        path: '/zebra',
        name: 'zebra',
        component: Zebra,
      },

    ],
  },
  {
    path: '/active-logins',
    name: 'active-logins',
    component: ActiveLogins,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
